import { render, staticRenderFns } from "./RatingComponent.vue?vue&type=template&id=8dd24b44&scoped=true"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"
import style0 from "./RatingComponent.vue?vue&type=style&index=0&id=8dd24b44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd24b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dd24b44')) {
      api.createRecord('8dd24b44', component.options)
    } else {
      api.reload('8dd24b44', component.options)
    }
    module.hot.accept("./RatingComponent.vue?vue&type=template&id=8dd24b44&scoped=true", function () {
      api.rerender('8dd24b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/RatingComponent.vue"
export default component.exports